import { Layout } from 'components/layout';
import React, { useState } from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../carousel/carousel';
import { Tab, Tabs } from '../tabs/tabs';

const tabsSetting = [
  "1, 2 корпус", 
  "3 корпус"
]

const imageSlidesFirstSecondGroup = [
  {
    src: "/assets/images/webp/gallery/main.webp",
    alt: "carousel-image main",
  },
  {
    src: "/assets/images/webp/gallery/child.webp",
    alt: "carousel-image child",
  },
  {
    src: "/assets/images/webp/gallery/view_road.webp",
    alt: "carousel-image view_road",
  },
  {
    src: "/assets/images/webp/gallery/about.webp",
    alt: "carousel-image about",
  },
  {
    src: "/assets/images/webp/gallery/upper_view.webp",
    alt: "carousel-image upper_view",
  },
] satisfies Array<{ src: string, alt: string}>;

const imageSlidesThirdGroup = [
  {
    src: "/assets/images/png/about.jpg",
    alt: "carousel-image about",
  },
  {
    src: "/assets/images/png/main2.jpg",
    alt: "carousel-image main",
  },
  {
    src: "/assets/images/png/2.jpg",
    alt: "carousel-image 2",
  },
  {
    src: "/assets/images/png/5.jpg",
    alt: "carousel-image 5",
  },
  {
    src: "/assets/images/png/4.jpg",
    alt: "carousel-image 4",
  },
] satisfies Array<{ src: string, alt: string}>;

export const AdvantagesCarousel = () => {
     const [isThirdGroupFlat, setIsThirdGroupFlat] = useState(false);
  return (
    <div>
      <Layout.Container>
        <Tabs startActivePos={0} className={"max-w-sm me-auto my-3 screen-500:mx-auto"} onClick={(tab) => {
          if (tab === tabsSetting?.[1]) {
            setIsThirdGroupFlat(true);
          } else {
            setIsThirdGroupFlat(false);
          }
        }}>
          {Array.isArray(tabsSetting) && tabsSetting.map((label, i) => (
            <Tab label={label} key={`${i}-tabsFlat`} />
          ))}
        </Tabs>
        <div className="relative">
          <Carousel 
          key={`${isThirdGroupFlat}`}
          >
            <CarouselContent className='cursor-move'>
              {(!isThirdGroupFlat ? imageSlidesFirstSecondGroup : imageSlidesThirdGroup).map(({ src, alt }, index) => (
                <CarouselItem className='' key={src + index} >
                  <img
                    src={src}
                    alt={alt}
                    className="rounded-[20px] screen-900:rounded-none max-h-[960px]"
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="absolute top-[49px] left-[33px] flex items-center gap-4 screen-900:hidden">
              <CarouselPrevious className="absolute top-0 left-0 border-plt-secondary border-[2px] bg-plt-secondary" />
              <CarouselNext className="absolute top-0 left-[40px] border-plt-secondary border-[2px] bg-plt-secondary" />
            </div>
            <div className="hidden screen-900:flex justify-center items-center gap-2 mt-10">
              <CarouselPrevious className="static size-[56px] top-0 border-plt-secondary border-2 bg-plt-secondary" />
              <CarouselNext className="static size-[56px] top-0 border-plt-secondary border-2 bg-plt-secondary" />
            </div>
          </Carousel>
        </div>
      </Layout.Container>
    </div>
  );
};
